import type { ExperienceManifest } from '../../types'

export const manifest: ExperienceManifest = {
  version: '1.0.0',
  schemaVersion: '1.0.0',
  minimumFrameworkVersion: '1.0.0',
  capabilities: {
    supportsAudio: false,
    supportsInteraction: true,
    supportsReplay: true,
    supportsReducedMotion: true,
    supportsLocalization: false,
    supportsAnalytics: true,
    supportsCelebration: false,
  },
  metadata: {
    id: 'progress-timeline',
    name: 'Progress Timeline',
    description: 'A linear progress milestone grid mapping completed goals and current execution speeds.',
    category: 'entrance',
    themePreference: 'both',
  },
  eligibility: {
    check: (context) => context.user.completedGoalsCount > 0,
    cooldownMs: 24 * 60 * 60 * 1000,
    basePriority: 65,
  },
  ComponentLoader: () => import('./component'),
  preload: async () => Promise.resolve(),
}

export default manifest
